export default __webpack_public_path__ + "static/media/Apercu-Italic.7bee9f96.otf";